import { Section } from './Section';
import { developPandasImage } from '@app/assets';

export function DevelopSection() {
  return (
    <Section
      img={<img src={developPandasImage} alt="three pandas" className="w-full max-w-[300px]" />}
      titleTranslationKey="develop_title"
      descriptionTranslationKey="develop_text"
    />
  );
}
